module.exports = __webpack_public_path__ + "img/7b6ce26.png";